<div class="pk-simulated-hands-wrap">
    @if (content) {
        <div class="theme-ex close-client-simu-btn" (click)="closeSimHands()"></div>
    }
</div>
